module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f632.b4a967b8.svg";